import React from 'react'
import FontIcon from 'react-md/lib/FontIcons'

import './ImagePlaceholder.css'

export default ({ icon, title }) => (
	<div className="image-placeholder">
		<FontIcon>{icon}</FontIcon>
		<p>{title}</p>
	</div>
);


// WEBPACK FOOTER //
// ./src/components/common/ImagePlaceholder.jsx